import { mainServer, BASIC_AUTH_HEADER } from '../../variables/config';


export const request_create_user = async(data) => {
  mainServer.defaults.headers.common['Authorization'] = BASIC_AUTH_HEADER
  const response = await mainServer.post(`/registration`, data)
  console.log(response.data)
}
